// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { LinkItemFragmentDoc } from '../../index.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const QuestionnaireStepFinalDocument = gql`
    query questionnaireStepFinal($id: ID!) {
  questionnaire(id: $id) {
    redirectLink {
      ...linkItem
    }
  }
}
    ${LinkItemFragmentDoc}`;

export function useQuestionnaireStepFinalQuery(options?: Omit<Urql.UseQueryArgs<never, SchemaTypes.QuestionnaireStepFinalQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SchemaTypes.QuestionnaireStepFinalQuery, SchemaTypes.QuestionnaireStepFinalQueryVariables | undefined>({ query: QuestionnaireStepFinalDocument, variables: undefined, ...options });
};